<template>
  <svg
    :class="computedClass"
    :width="width"
    :height="height"
    viewBox="0 0 10 6"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9 5L5 1L1 5"
      :stroke="color"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script setup lang="ts">
import { computed } from "vue";

interface Props {
  width?: number | string;
  height?: number | string;
  color?: string;
  class?: string | Record<string, boolean> | string[];
}

const props = withDefaults(defineProps<Props>(), {
  width: 8,
  height: 4,
  color: "currentColor",
  class: () => [] as string[],
});

const computedClass = computed(() => props.class as any);
</script>
